import { Alert, AlertDescription } from '@sunstone/ui';
import { XCircle } from 'lucide-react';
import type { BlockRendererProps } from '../registry';

export function ErrorBlockRenderer({ block }: BlockRendererProps) {
  return (
    <Alert variant="destructive" className="my-1">
      <XCircle className="h-4 w-4" />
      <AlertDescription>{block.content || 'An error occurred.'}</AlertDescription>
    </Alert>
  );
}
